import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "error", "submitButton"]

    connect() {
        this.checkFile();
    }

    checkFile() {
        const input = this.inputTarget.files[0];
        console.log(this.inputTarget);
        if (!input) return; // No file selected

        const maxFileSize = 10 * 1024 * 1024; // 10MB
        const allowedTypes = [
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/rtf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        if (input.size > maxFileSize) {
            this.showError("Le fichier doit être inférieur à 10 Mo.");
            this.disableSubmit()
        } else if (!allowedTypes.includes(input.type)) {
            this.showError("Le fichier doit être un PDF, DOC, TXT, ou RTF.");
            this.disableSubmit()
        } else {
            this.clearError();
            this.enableSubmit();
        }
    }

    showError(message) {
        this.errorTarget.innerHTML = `<p class="mt-2 text-pink-600 text-md">${message}</p>`
        this.errorTarget.style.display = 'block';
    }

    clearError() {
        this.errorTarget.innerHTML = '';
        this.errorTarget.style.display = 'none';
    }

    disableSubmit() {
        if ((this.hasSubmitButtonTarget)) {
            this.submitButtonTarget.disabled = true;
        }
    }

    enableSubmit() {
        if ((this.hasSubmitButtonTarget)) {
            this.submitButtonTarget.disabled = false;
        }
    }
}
